<template>
  <div>
    <PageHeader :line="false">
      <el-input
        size="mini"
        prefix-icon="el-icon-search"
        placeholder="Search"
        v-model="searchVal"
        v-debounce="onSearch"
        clearable
        @clear="onSearch"
      />
    </PageHeader>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="Loading..."
      ref="table"
      @sort-change="onSortChange"
    >
     
      <el-table-column label="No." width="95" prop="No" sortable="custom" />
      <el-table-column
        label="File Name"
        min-width="250"
        prop="FileName"
        sortable="custom"
      >
      <template #default="{ row }">
            <a :href="row.AttachmentPath" target="_blank">{{ row.FileName }}</a>
          </template>
          </el-table-column>
      <el-table-column
        label="Content Category"
        min-width="180"
        prop="CategoryName"
        sortable="custom"
      />
      <el-table-column
        prop="levelName"
        label="Security Level"
        sortable="custom"
        min-width="140"
      />
      <el-table-column
        prop="Hits"
        label="No.Hits"
        sortable="custom"
        min-width="120"
      />
      <el-table-column
        prop="Download"
        label="No.Download"
        sortable="custom"
        min-width="140"
      />
      <el-table-column
        prop="Duration"
        label="Duration(s)"
        sortable="custom"
        min-width="120"
      />
      <el-table-column
        label="Pushed Date"
        min-width="160"
        prop="SentOn"
        sortable="custom"
      />
      <!-- <el-table-column
        label="Push Type"
        width="130"
        prop="PushType"
        sortable="custom"
      />
      <el-table-column
        label="Content Category"
        min-width="180"
        prop="CategoryName"
        sortable="custom"
      />
      <el-table-column
        label="Short Title"
        min-width="160"
        prop="ShortTitle"
        sortable="custom"
      />
      <el-table-column
        label="Search Term"
        min-width="160"
        prop="SearchTerm"
        sortable="custom"
      />
      <el-table-column
        prop="levelName"
        label="Security Level"
        sortable="custom"
        min-width="140"
      />
      <el-table-column
        label="Pushed Date"
        min-width="160"
        prop="SentOn"
        sortable="custom"
      />
      <el-table-column
        label="Operation"
        min-width="160"
        prop="StatusDesc"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-button
            type="text"
            icon="iconfont icon-read"
            @click="handleViewPaper(row)"
          />
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination-wrap">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
    <ViewPaperDialog
      :visible.sync="viewPaperDialogVisible"
      :data.sync="rowData"
    />
    <ViewCommentDialog
      :visible.sync="viewCommentDialogVisible"
      :data.sync="rowData"
    />
  </div>
</template>

<script>
import ViewPaperDialog from './view-paper-dialog'
import ViewCommentDialog from './view-comment-dialog'
export default {
  name: 'PushedContent',
  components: { ViewPaperDialog, ViewCommentDialog },
  data() {
    return {
      tableLoading: true,
      searchVal: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: 'CreatedOn',
      orderType: 'descending',
      viewPaperDialogVisible: false,
      viewCommentDialogVisible: false,
      rowData: null,
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    closeDialog() {
      this.viewPaperDialogVisible = false
      this.viewCommentDialogVisible = false
    },
    onSearch() {
      this.currentPage = 1
      this.getTableData()
    },
    onSortChange(column) {
      this.orderBy = column.prop
      this.orderType = column.order
      this.getTableData()
    },
    getTableData() {
      this.tableLoading = true
      let params = {
        ...this.params,
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      }
      this.axios
        .get(`/seDetail/viewPush`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data
            this.total = data.total
          } else {
            this.$message({
              type: 'error',
              message: msg,
            })
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getTableData()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getTableData()
    },
    handleViewPaper(row) {
      this.rowData = row
      this.viewPaperDialogVisible = true
    },
    handleViewComment(row) {
      this.rowData = row
      this.viewCommentDialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
